import {ITabInfo} from "./tab-info-interface";
import {GUID} from "app/shared/models/GUID-interface";

export class TabDataGUID implements GUID{
    constructor(public readonly GUID: string, public readonly data:  ITabInfo[]){
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/tab-data-GUID.ts